module.exports = __webpack_public_path__ + "static/media/Steppr_view_overview.e6afe3de.png";